import { render, staticRenderFns } from "./GTransitionDialog.vue?vue&type=template&id=0faafa3c&scoped=true&"
import script from "./GTransitionDialog.vue?vue&type=script&lang=ts&"
export * from "./GTransitionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./GTransitionDialog.vue?vue&type=style&index=0&id=0faafa3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faafa3c",
  null
  
)

export default component.exports